module.exports = __webpack_public_path__ + "static/img/9-3.a723329.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/9-3.jpg
// module id = UjjW
// module chunks = 0